/* ==========================================================================
   GOLAM golam.js
   Header scroll state, mobile nav, accordions, quantity steppers, size
   segmented control, scroll reveals, and a cart drawer that opens and updates.
   Config-driven: window.GOLAM = { mode, ... }.
     mode "mock"    : client-side cart over inline seeded products (mockup).
     mode "shopify" : Shopify AJAX cart (/cart.js, /cart/add.js, ...).
   The same file ships in the mockup and as a theme asset.
   ========================================================================== */
(function () {
  "use strict";
  var CFG = window.GOLAM || { mode: "mock" };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---- Money -------------------------------------------------------------- */
  function money(cents) {
    var v = (cents || 0) / 100;
    var s = (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2);
    return "$" + s.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  /* ---- Smoke renderer (canvas particle plume for the intro) -------------- */
  function startSmoke(canvas) {
    var ctx = canvas.getContext && canvas.getContext("2d");
    if (!ctx) return null;
    var DPR = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0, srcX = 0, srcY = 0;
    function resize() {
      W = canvas.clientWidth || window.innerWidth;
      H = canvas.clientHeight || window.innerHeight;
      canvas.width = Math.round(W * DPR); canvas.height = Math.round(H * DPR);
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      srcX = W * 0.5; srcY = H * 0.72;
    }
    resize();
    window.addEventListener("resize", resize);

    // soft particle sprite, drawn once and blitted (fast on mobile)
    var sprite = document.createElement("canvas");
    sprite.width = sprite.height = 128;
    var sx = sprite.getContext("2d");
    var sg = sx.createRadialGradient(64, 64, 0, 64, 64, 64);
    sg.addColorStop(0, "rgba(239,233,220,0.92)");
    sg.addColorStop(0.5, "rgba(239,233,220,0.30)");
    sg.addColorStop(1, "rgba(239,233,220,0)");
    sx.fillStyle = sg; sx.fillRect(0, 0, 128, 128);

    var COUNT = W < 640 ? 40 : 80;
    var parts = [];
    function spawn(p, seeded) {
      p.x = srcX + (Math.random() - 0.5) * 34;
      p.y = srcY + Math.random() * 12;
      p.vx = (Math.random() - 0.5) * 0.22;
      p.vy = -(0.40 + Math.random() * 0.45);
      p.r = 9 + Math.random() * 16;
      p.ttl = 150 + Math.random() * 130;
      p.life = seeded ? Math.random() * p.ttl : 0;
      p.seed = Math.random() * 1000;
    }
    for (var i = 0; i < COUNT; i++) { var p = {}; spawn(p, true); parts.push(p); }

    var raf = null;
    function frame() {
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.life++;
        if (p.life >= p.ttl) { spawn(p, false); continue; }
        p.vx += Math.sin(p.y * 0.015 + p.seed) * 0.010; // curl
        p.x += p.vx; p.y += p.vy;
        p.vy *= 0.996; p.r += 0.45;
        var lr = p.life / p.ttl;
        var a = Math.sin(lr * Math.PI) * 0.11;
        if (a <= 0.002) continue;
        ctx.globalAlpha = a;
        ctx.drawImage(sprite, p.x - p.r, p.y - p.r, p.r * 2, p.r * 2);
      }
      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(frame);
    }
    raf = requestAnimationFrame(frame);

    return {
      stop: function () {
        if (raf) cancelAnimationFrame(raf);
        raf = null;
        window.removeEventListener("resize", resize);
      }
    };
  }

  /* ---- Hero intro (smoke rises, dissipates, reveals the wordmark) -------- */
  (function intro() {
    var el = $("[data-intro]");
    if (!el) return;
    // ?intro (or #intro) forces a replay, ignoring the once-per-session flag.
    var force = location.search.indexOf("intro") > -1 || location.hash.indexOf("intro") > -1;
    var seen = document.documentElement.classList.contains("intro-seen");
    var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!force && (seen || reduced)) { el.parentNode && el.parentNode.removeChild(el); return; }

    var html = document.documentElement;
    var prevOverflow = html.style.overflow;
    html.style.overflow = "hidden"; // lock scroll while it plays
    el.classList.add("is-playing");

    var smokeCanvas = el.querySelector("[data-smoke]");
    var smoke = smokeCanvas ? startSmoke(smokeCanvas) : null;

    var DURATION = parseInt(el.getAttribute("data-duration") || "3600", 10);
    var done = false;

    // drive the loading counter + progress bar over the first ~68% of the run
    var counter = el.querySelector("[data-intro-counter]");
    var bar = el.querySelector("[data-intro-bar]");
    var cStart = null, cDur = DURATION * 0.68;
    function tickCounter(ts) {
      if (done) return;
      if (cStart === null) cStart = ts;
      var pr = Math.min(1, (ts - cStart) / cDur);
      var e = 1 - Math.pow(1 - pr, 2); // ease out
      if (counter) counter.textContent = ("00" + Math.round(e * 100)).slice(-3);
      if (bar) bar.style.width = (e * 100).toFixed(1) + "%";
      if (pr < 1) requestAnimationFrame(tickCounter);
    }
    if (counter || bar) requestAnimationFrame(tickCounter);

    function finish() {
      if (done) return; done = true;
      if (counter) counter.textContent = "100";
      if (bar) bar.style.width = "100%";
      if (smoke) smoke.stop();
      el.classList.add("is-done");
      html.style.overflow = prevOverflow;
      try { sessionStorage.setItem("golam_intro_seen", "1"); } catch (e) {}
      var remove = function () { el.parentNode && el.parentNode.removeChild(el); };
      el.addEventListener("transitionend", remove, { once: true });
      setTimeout(remove, 1200); // fallback if transitionend never fires
    }
    var timer = setTimeout(finish, DURATION);
    var skip = $("[data-intro-skip]", el);
    if (skip) skip.addEventListener("click", function () { clearTimeout(timer); finish(); });
    document.addEventListener("keydown", function onKey(e) {
      if (e.key === "Escape" && !done) { clearTimeout(timer); finish(); document.removeEventListener("keydown", onKey); }
    });
  })();

  /* ---- Header: solid on scroll ------------------------------------------- */
  (function header() {
    var bar = $("[data-topbar]");
    if (!bar) return;
    // Pages that are not transparent over a hero stay solid.
    if (!bar.hasAttribute("data-transparent")) { bar.classList.add("is-solid"); return; }
    var onScroll = function () { bar.classList.toggle("is-solid", window.scrollY > 24); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  })();

  /* ---- Scheme toggle (mockup preview: Bone / Obsidian) ------------------- */
  (function schemeToggle() {
    var btn = $("[data-scheme-toggle]");
    if (!btn) return;
    var label = $("[data-scheme-label]", btn);
    var html = document.documentElement;
    function sync() {
      var light = html.classList.contains("scheme-light");
      if (label) label.textContent = light ? "Obsidian" : "Bone";
      btn.setAttribute("aria-pressed", light ? "true" : "false");
    }
    sync();
    btn.addEventListener("click", function () {
      var light = html.classList.toggle("scheme-light");
      try { localStorage.setItem("golam_scheme", light ? "light" : "dark"); } catch (e) {}
      sync();
    });
  })();

  /* ---- Mobile nav -------------------------------------------------------- */
  (function mobileNav() {
    var t = $(".nav-toggle"), nav = $(".nav");
    if (!t || !nav) return;
    t.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      t.setAttribute("aria-expanded", open ? "true" : "false");
    });
    $$(".nav a").forEach(function (a) {
      a.addEventListener("click", function () { nav.classList.remove("is-open"); t.setAttribute("aria-expanded", "false"); });
    });
  })();

  /* ---- Accordions -------------------------------------------------------- */
  (function accordions() {
    $$(".acc__item").forEach(function (item) {
      var head = $(".acc__head", item), panel = $(".acc__panel", item);
      if (!head || !panel) return;
      head.setAttribute("aria-expanded", "false");
      head.addEventListener("click", function () {
        var open = item.classList.toggle("is-open");
        head.setAttribute("aria-expanded", open ? "true" : "false");
        panel.style.height = open ? panel.scrollHeight + "px" : "0px";
      });
    });
  })();

  /* ---- Scroll reveal ----------------------------------------------------- */
  (function reveal() {
    var els = $$(".reveal");
    if (!("IntersectionObserver" in window) || !els.length) {
      els.forEach(function (e) { e.classList.add("is-in"); }); return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (e) { io.observe(e); });
  })();

  /* ---- Quantity steppers (generic) --------------------------------------- */
  function bindStepper(scope) {
    $$(".qty", scope).forEach(function (q) {
      if (q.__bound) return; q.__bound = true;
      var input = $("input", q), dec = $("[data-dec]", q), inc = $("[data-inc]", q);
      var min = parseInt(q.getAttribute("data-min") || "1", 10);
      function set(v, fire) {
        v = Math.max(min, v || min);
        input.value = v;
        if (fire && q.dataset.key) Cart.update(q.dataset.key, v);
      }
      dec && dec.addEventListener("click", function () { set(parseInt(input.value, 10) - 1, true); });
      inc && inc.addEventListener("click", function () { set(parseInt(input.value, 10) + 1, true); });
      input && input.addEventListener("change", function () { set(parseInt(input.value, 10), true); });
    });
  }
  bindStepper(document);

  /* ---- Size segmented control + add to cart (PDP) ------------------------ */
  (function pdp() {
    var seg = $(".seg[data-variants]");
    if (!seg) return;
    var variants = JSON.parse(seg.getAttribute("data-variants"));
    var priceEl = $("[data-price]");
    var current = variants[seg.querySelector('[aria-pressed="true"]') ?
      [].indexOf.call(seg.children, seg.querySelector('[aria-pressed="true"]')) : 0] || variants[0];

    var idInput = $("[data-variant-id]"); // hidden field for the no-JS product form
    function select(i) {
      current = variants[i];
      $$("button", seg).forEach(function (b, j) { b.setAttribute("aria-pressed", j === i ? "true" : "false"); });
      if (priceEl) priceEl.textContent = money(current.price);
      if (idInput && current.id != null) idInput.value = current.id;
      if (current.available === false) { if (add) { add.setAttribute("disabled", ""); add.textContent = add.getAttribute("data-soldout") || "Sold out"; } }
      else if (add) { add.removeAttribute("disabled"); add.textContent = add.getAttribute("data-label") || "Add to cart"; }
    }
    var add = $("[data-add]");
    $$("button", seg).forEach(function (b, i) { b.addEventListener("click", function () { select(i); }); });

    if (add) add.addEventListener("click", function (e) {
      e.preventDefault(); // JS path uses AJAX; the form remains a no-JS fallback
      var qtyEl = $('[data-add-qty] input');
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      Cart.add({
        id: current.id, productId: seg.getAttribute("data-product"),
        scent: seg.getAttribute("data-scent"), size: current.size,
        price: current.price, image: seg.getAttribute("data-image") || ""
      }, qty);
    });
  })();

  /* ====================================================================== */
  /*  CART                                                                   */
  /* ====================================================================== */
  var drawer = $("[data-drawer]"), scrim = $("[data-scrim]");
  var countEls = $$("[data-cart-count]");

  function openDrawer() {
    if (scrim) scrim.classList.add("is-open");
    if (drawer) { drawer.classList.add("is-open"); drawer.setAttribute("aria-hidden", "false"); }
    var c = $(".drawer__close"); if (c) c.focus();
  }
  function closeDrawer() {
    if (scrim) scrim.classList.remove("is-open");
    if (drawer) { drawer.classList.remove("is-open"); drawer.setAttribute("aria-hidden", "true"); }
  }
  $$("[data-cart-open]").forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); openDrawer(); }); });
  $$("[data-cart-close]").forEach(function (b) { b.addEventListener("click", closeDrawer); });
  if (scrim) scrim.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

  function setCount(n) {
    countEls.forEach(function (el) { el.textContent = n; el.setAttribute("data-count", n); });
  }

  function renderDrawer(cart) {
    var list = $("[data-drawer-items]");
    var foot = $("[data-drawer-foot]");
    if (!list) return;
    if (!cart.items.length) {
      list.innerHTML =
        '<div class="drawer__empty">' +
          '<svg class="mk" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3 4 21h2.6L12 8.4 17.4 21H20L12 3Z"/></svg>' +
          '<p>Your cart is quiet for now.</p>' +
          '<a class="link-arrow" href="' + (CFG.shopUrl || "product.html") + '">View the collection' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h15m0 0-5-5m5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.4"/></svg></a>' +
        '</div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    list.innerHTML = cart.items.map(function (it) {
      return '' +
      '<div class="line" data-line="' + it.key + '">' +
        '<div class="line__media">' + mediaFallback(it.image, it.scent) + '</div>' +
        '<div>' +
          '<div class="line__name">' + it.scent + '</div>' +
          '<div class="line__size">' + it.size + '</div>' +
          '<div class="line__bottom">' +
            '<div class="qty" data-key="' + it.key + '" data-min="1">' +
              '<button type="button" data-dec aria-label="Decrease quantity">' + iconMinus() + '</button>' +
              '<input type="text" inputmode="numeric" value="' + it.qty + '" aria-label="Quantity">' +
              '<button type="button" data-inc aria-label="Increase quantity">' + iconPlus() + '</button>' +
            '</div>' +
          '</div>' +
          '<button class="line__remove" data-remove="' + it.key + '">Remove</button>' +
        '</div>' +
        '<div class="line__price num">' + money(it.price * it.qty) + '</div>' +
      '</div>';
    }).join("");
    var sub = $("[data-subtotal]"); if (sub) sub.textContent = money(cart.total);
    bindStepper(list);
    $$("[data-remove]", list).forEach(function (b) {
      b.addEventListener("click", function () { Cart.update(b.getAttribute("data-remove"), 0); });
    });
  }

  function mediaFallback(src, label) {
    if (src) return '<img src="' + src + '" alt="' + label + '" loading="lazy">';
    return '<div class="imgfall"><svg class="mk" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3 4 21h2.6L12 8.4 17.4 21H20L12 3Z"/></svg></div>';
  }
  function iconMinus() { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>'; }
  function iconPlus() { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>'; }

  /* ---- Mock backend ------------------------------------------------------ */
  var MockCart = (function () {
    var KEY = "golam_cart_v1";
    var items = [];
    try { items = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { items = []; }
    function save() { try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {} }
    function totals() {
      var t = 0, n = 0;
      items.forEach(function (i) { t += i.price * i.qty; n += i.qty; });
      return { items: items, total: t, count: n };
    }
    return {
      get: function () { return totals(); },
      add: function (v, qty) {
        var key = v.id || (v.productId + ":" + v.size);
        var found = items.filter(function (i) { return i.key === key; })[0];
        if (found) found.qty += qty;
        else items.push({ key: key, scent: v.scent, size: v.size, price: v.price, qty: qty, image: v.image });
        save(); return Promise.resolve(totals());
      },
      update: function (key, qty) {
        items = items.filter(function (i) {
          if (i.key === key) { i.qty = qty; return qty > 0; }
          return true;
        });
        save(); return Promise.resolve(totals());
      }
    };
  })();

  /* ---- Shopify backend --------------------------------------------------- */
  var ShopifyCart = (function () {
    function map(cart) {
      return {
        items: cart.items.map(function (it) {
          return {
            key: it.key, scent: it.product_title, size: (it.variant_title || ""),
            price: it.final_price, qty: it.quantity, image: it.image
          };
        }),
        total: cart.total_price, count: cart.item_count
      };
    }
    function fetchCart() { return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(map); }
    return {
      get: fetchCart,
      add: function (v, qty) {
        return fetch("/cart/add.js", {
          method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: v.id, quantity: qty })
        }).then(fetchCart);
      },
      update: function (key, qty) {
        return fetch("/cart/change.js", {
          method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(fetchCart);
      }
    };
  })();

  var Backend = CFG.mode === "shopify" ? ShopifyCart : MockCart;

  var Cart = {
    add: function (v, qty) {
      Backend.add(v, qty || 1).then(function (c) { paint(c); openDrawer(); });
    },
    update: function (key, qty) { Backend.update(key, qty).then(paint); },
    refresh: function () { Promise.resolve(Backend.get()).then(paint); }
  };
  function paint(c) { setCount(c.count); renderDrawer(c); }
  window.GolamCart = Cart;

  Cart.refresh();
})();
